export default __webpack_public_path__ + "media/images/navigate_plus-50e51d6ce0ae2049c1b2441115d53a0b.png";